import { createContext } from 'react';

export interface EstateResultItemState {
  isEditingEstateResultItem: boolean;
  estateResultItemIdToEdit: string | null;
  setContext: React.Dispatch<React.SetStateAction<EstateResultItemState>>;
}

const defaultValues: EstateResultItemState = {
  isEditingEstateResultItem: false,
  estateResultItemIdToEdit: null,
  setContext: () => {},
};

export const EstateResultsPageContext = createContext<EstateResultItemState>(defaultValues);
